export default __webpack_public_path__ + "static/calidad-de-la-gestion-large-e19c79feccc166b2aa90db622811aa43.svg";